/**
 * Icons can be styled with a gradient by using the `url(#icon-gradient)` stroke.
 * gradientUnits="userSpaceOnUse" requires the icons to use viewBox="0 0 24 24" which is the case with Tabler icons.
 * gradientUnits="objectBoundingBox" cannot be used because some Tabler icons don't work with it (e.g. IconArrowRight).
 */

export default function IconGradient() {
  return (
    <svg width="0" height="0" className="pointer-events-none absolute">
      <defs>
        <linearGradient
          id="icon-gradient"
          x1="0"
          y1="0"
          x2="24"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="var(--color-primary-400)" />
          <stop offset="100%" stopColor="var(--color-secondary-400)" />
        </linearGradient>
      </defs>
    </svg>
  );
}
